import {TimeZone} from '@hconnect/common/types'
import {FC} from 'react'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router'

import {PageHeader, DateTimeRangePicker} from '../components'
import {FEATURE_NAMESPACE} from '../consts'

type StoppageAnalysisHeaderProps = {
  timeRangeParam: string
  onTimeRangeParamChange: (timeRange: string) => void
  timezone: TimeZone
  onAdjustModeClick: () => void
  isAdjustMode: boolean
  disableAdjustMode: boolean
  pageTitle?: string
}

export const StoppageAnalysisHeader: FC<StoppageAnalysisHeaderProps> = ({
  timezone,
  timeRangeParam,
  onTimeRangeParamChange,
  disableAdjustMode,
  onAdjustModeClick,
  isAdjustMode,
  pageTitle
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const navigate = useNavigate()

  const handleGoBack = () => {
    void navigate(-1)
  }

  return (
    <PageHeader
      filterComponent={
        <DateTimeRangePicker
          timeRangeParam={timeRangeParam}
          onTimeRangeParamChange={onTimeRangeParamChange}
          timezone={timezone}
          disabled={isAdjustMode}
        />
      }
      title={pageTitle}
      backButtonProps={{
        targetName: t('stoppageAnalysis.action.goBack'),
        target: ''
      }}
      onGoBackClick={handleGoBack}
    />
  )
}
